import type { ComponentSingleStyleConfig } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

// You can also use the more specific type for
// a single part component: ComponentSingleStyleConfig
export const Heading: ComponentSingleStyleConfig = {
  // The styles all teext have in common
  baseStyle: {
    color: primaryColor.text.bgColorText // <-- color is same for all variants
  },
  // variants
  variants: {
    '4XL': { fontWeight: 'semibold', fontSize: '4xl', lineHeight: '73px' },
    '3XL': { fontWeight: 'medium', fontSize: '3xl', lineHeight: '65px' },
    '2XL': { fontWeight: 'medium', fontSize: '2xl', lineHeight: '59px' },
    XL: { fontWeight: 'medium', fontSize: 'xl', lineHeight: '47px' },
    LG: { fontWeight: 'semibold', fontSize: 'lg', lineHeight: '37px' },
    MD: { fontWeight: 'semibold', fontSize: 'md', lineHeight: '30px' },
  },
  // The default variant values
  defaultProps: {
    variant: 'XL',
  },
}
